import React, { useMemo } from 'react';
import aboutData from '../data/javascripts/aboutData';

const About = () => {
    const themeClasses = useMemo(() => ({
        sectionBg: 'bg-bg-light dark:bg-bg-dark',
        headingText: 'text-primary dark:text-secondary',
        bodyText: 'text-text-light dark:text-text-dark',
    }), []);


    return (
        <section id="about" className={`${themeClasses.sectionBg}`}>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
                
                {/* --- Header Section --- */}
                <div className="text-center mb-12">
                    <h2 className={`text-4xl font-bold mb-2 ${themeClasses.headingText}`}>
                        About Me
                    </h2>
                </div>
                
                {/* --- Content Row (Portrait + Description) --- */}
                <div className="flex flex-col lg:flex-row justify-center items-start lg:gap-12">
                    
                    {/* Portrait Column - Left Side */}
                    <div className="w-full mb-8 lg:mb-0 mx-auto lg:mx-0 lg:max-w-md"> 
                        <div className="w-full">
                            <img
                                src={aboutData.portraitImage}
                                alt={aboutData.portraitAlt}
                                // Added rounded-lg back to the image element
                                className={`w-full h-auto object-cover rounded-lg transition duration-300 ease-in-out 
                                    transform hover:scale-[1.05]`}
                            />
                        </div>
                    </div>

                    {/* Description and Signature Column - Right Side */}
                    <div className="w-full lg:w-6/12">
                        <div className={`space-y-6 text-lg ${themeClasses.bodyText}`}>
                            {/* Description text with dangerouslySetInnerHTML */}
                            <p 
                                className="leading-relaxed" 
                                dangerouslySetInnerHTML={{ __html: aboutData.description }} 
                            />
                            
                            {/* Signature image */}
                            <div className="mt-8 text-right pt-4">
                                <img
                                    src={aboutData.signatureImage}
                                    alt={aboutData.signatureAlt}
                                    className="h-auto w-auto max-w-[200px] inline-block"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;